var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-flex rounded-full px-2",class:{
    'bg-green-500 text-green-50': _vm.status === 'paid',
    'bg-red-500 text-red-50': _vm.status === 'failed',
    'bg-yellow-500 text-yellow-50': _vm.status === 'pending' || _vm.status === 'init',
    'text-sm leading-6 font-medium': !_vm.small,
    'text-xs leading-5 font-semibold': _vm.small,
  }},[_vm._v(" "+_vm._s(_vm.$t(("paymentStatusTypes." + _vm.status)))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }